<div>
  <h3>{{ "automatic-request.title" | translate }}</h3>
  <h5>{{ "automatic-request.subtitle" | translate }}</h5>
</div>

<!--
  Acomodo segun el ancho del componente padre: con espacio, intervalos y horas
  lado a lado; en contenedores angostos (.cfg-narrow) todo en una columna.
-->
<div class="auto-request">
  <div class="auto-request__intervals">
    <div class="auto-request__radios">
      <div>
        <div class="form-check mr-2">
          <input
            class="form-check-input"
            type="radio"
            name="interval"
            value="EVERY_HOUR"
            id="every_hour_hydro"
            [(ngModel)]="interval"
            [checked]="interval === 'EVERY_HOUR'"
          />
          <label class="form-check-label" for="every_hour_hydro"> {{ "automatic-request.every-hour" | translate }} </label>
        </div>
      </div>
      <div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="interval"
            value="EVERY_3_HOURS"
            id="every_3_hours_hydro"
            [(ngModel)]="interval"
            [checked]="interval === 'EVERY_3_HOURS'"
            (change)="validatechangedays('EVERY_3_HOURS')"
          />
          <label class="form-check-label" for="every_3_hours_hydro"> {{ "automatic-request.3-times-a-day" | translate }} </label>
        </div>
      </div>
      <div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="interval"
            value="EVERY_5_HOURS"
            id="every_5_hours_hydro"
            [(ngModel)]="interval"
            [checked]="interval === 'EVERY_5_HOURS'"
            (change)="validatechangedays('EVERY_5_HOURS')"
          />
          <label class="form-check-label" for="every_5_hours_hydro"> {{ "automatic-request.5-times-a-day" | translate }} </label>
        </div>
      </div>
    </div>
  </div>
  <div class="auto-request__hours" *ngIf="interval !== 'EVERY_HOUR'">
    <div>
      <select
        class="form-control"
        name="hours_hydro"
        id="hours_hydro"
        (change)="changeSelectHours($event.target.value)"
      >
        <option value="">{{ "automatic-request.select-hour-of-day" | translate }}</option>
        <option *ngFor="let item of temporalHours;" [value]="item">{{item}}</option>
      </select>
    </div>
    <div>
      <div
        class="d-flex align-items-center flex-wrap"
        *ngIf="hoursSelected && hoursSelected.length > 0"
      >
        <span
          class="m-0 mr-2 font-weight-bold item-delete mt-2"
          *ngFor="let item of hoursSelected;let i = index;"
          (click)="deleteHour(i)"
          >{{item}} <em class="fa fa-times-circle text-danger"></em
        ></span>
      </div>
    </div>
  </div>
  <div class="auto-request__actions" *ngIf="permissions.change_parametricpreference">
    <button class="btn btn-primary" (click)="submitAutomaticRequest()">
      {{ "admin.organization.save-info" | translate }}
    </button>

    <button
      class="btn btn-secondary"
      *ngIf="type === 'waterwise' || type === 'feeder'"
      (click)="setConfig()"
    >
      {{ "automatic-request.send-config-to-device" | translate }}
    </button>
  </div>
</div>
